import type React from "react";

import { noop } from "lodash";

import { PlainTooltip, CountryChipItem, SimpleChipItem } from "@similarweb/ui-components";

import DropdownButton from "app/pages/workspace/sales/components/custom-dropdown/DropdownButton/DropdownButton";

import { StyledChipItemWrapper } from "./styles";

type CountryDropdownButtonProps = {
    isDisabled: boolean;
    selectedIds: readonly number[];
    buttonText: string;
    tooltipText?: string;
    onCloseItem: (e: React.SyntheticEvent) => void;
};

function CountryDropdownButton({
    isDisabled,
    selectedIds,
    buttonText,
    tooltipText,
    onCloseItem,
}: CountryDropdownButtonProps) {
    function returnDropdownButton() {
        if (selectedIds.length === 1) {
            return (
                <StyledChipItemWrapper>
                    <CountryChipItem
                        text={buttonText}
                        id={selectedIds[0]}
                        onCloseItem={onCloseItem as () => void}
                    />
                </StyledChipItemWrapper>
            );
        }

        if (selectedIds.length > 1) {
            return (
                <PlainTooltip
                    maxWidth={170}
                    placement="top"
                    tooltipContent={tooltipText}
                >
                    <StyledChipItemWrapper>
                        <SimpleChipItem
                            text={buttonText}
                            onCloseItem={onCloseItem}
                        />
                    </StyledChipItemWrapper>
                </PlainTooltip>
            );
        }

        return (
            <DropdownButton
                selectedText={null}
                disabled={isDisabled}
                buttonText={buttonText}
                tooltipText={tooltipText}
                key="employee-location-dd-button"
                onClick={noop}
                onClose={noop}
            />
        );
    }

    return returnDropdownButton();
}

export default CountryDropdownButton;
